var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlogSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#00a0df;}.cls-2{fill:#fff;}.cls-3{stroke:#fff;stroke-miterlimit:10;stroke-width:50px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_141",
    "data-name": "Layer 141"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 300,
    cy: 300,
    r: 299.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 111.29,
    y: 298.98,
    width: 311.15,
    height: 69.15,
    rx: 34.58,
    transform: "translate(-157.7 286.4) rotate(-45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 343.08,
    cy: 254.48,
    r: 106.54
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogSearch);
export default __webpack_public_path__ + "static/media/blog_search.04f819b70c186428ad072bd7c6c93717.svg";
export { ForwardRef as ReactComponent };